import React from "react";
import { ConfigProvider, Form, Modal, theme } from "antd";
import type { FormInstance } from "antd";
import type { AdminConsoleMeta } from "../../../types";
import type { ModalMode, SelectedRecord } from "../constants";
import { singularize } from "../utils";
import { PrincipalFields } from "./PrincipalFields";
import { DomainFields } from "./DomainFields";
import { BackendRoleFields } from "./BackendRoleFields";

interface RecordModalProps {
  open: boolean;
  tab: ModalMode;
  form: FormInstance;
  selectedRecord: SelectedRecord;
  creatingNew: boolean;
  submitting: boolean;
  meta: AdminConsoleMeta | null;
  domainOptions: Array<{ label: string; value: string }>;
  backendRoleOptions: Array<{ label: string; value: string }>;
  onCancel: () => void;
  onOk: () => void;
}

export const RecordModal: React.FC<RecordModalProps> = ({
  open,
  tab,
  form,
  selectedRecord,
  creatingNew,
  submitting,
  meta,
  domainOptions,
  backendRoleOptions,
  onCancel,
  onOk,
}) => (
  <ConfigProvider
    theme={{
      algorithm: theme.defaultAlgorithm,
      token: {
        colorBgElevated: "#ffffff",
        colorBgContainer: "#ffffff",
        colorText: "#1f2937",
        colorTextHeading: "#111827",
        colorBorder: "#d1d5db",
        colorBorderSecondary: "#e5e7eb",
      },
    }}
  >
    <Modal
      open={open}
      title={creatingNew ? `New ${singularize(tab)}` : selectedRecord?.name || selectedRecord?.id}
      width={960}
      onCancel={onCancel}
      onOk={onOk}
      okText={submitting ? "Saving..." : "Save"}
      confirmLoading={submitting}
      forceRender
      styles={{
        header: { background: "#ffffff" },
        body: { background: "#ffffff" },
      }}
    >
      <Form form={form} layout="vertical" className="admin-console__form">
        {tab === "roles" ? (
          <BackendRoleFields meta={meta} />
        ) : tab === "domains" ? (
          <DomainFields />
        ) : (
          <PrincipalFields
            mode={tab === "admins" ? "admins" : "users"}
            domainOptions={domainOptions}
            backendRoleOptions={backendRoleOptions}
          />
        )}
      </Form>
    </Modal>
  </ConfigProvider>
);
